import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import { ROUTER } from '../../../class/constants'

import { Alert, Label, Loader } from '../../default'
import { acGetCustomerByEmail } from '../../../class/actions'

function PanelSearchEmail({
  classes,
  email,
  emailCustomer,
  isLoadingEmailCustomer,
  errorEmailCustomer,
  TableComponent
}) {
  const { t } = useTranslation(), dispatch = useDispatch(), history = useHistory()

  const historyRef = useRef(null)

  const [searchError, setSearchError] = useState(null)

  useEffect(() => {
    const search = () => {

      setSearchError(null)

      dispatch(acGetCustomerByEmail(email))
        .catch(() => {
          if (errorEmailCustomer && errorEmailCustomer.status !== 404)
            setSearchError(t('panels.search.email.unknown'))
        })
        .finally(() => {
          if (historyRef && historyRef.current)
            historyRef.current.scrollIntoView({ behavior: 'smooth' })
        })
    }

    search()

    // DO NOT DELETE NEXT LINE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2} className={classes.root}>

      {/* Title */}
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.search.result') + `"${email}"`}</Label>
      </Grid>

      {/* Error / Loading */}
      <Grid item xs={12}>
        { isLoadingEmailCustomer && <Loader /> }
        { searchError && <Alert text={searchError} color="error" noMargin /> }
      </Grid>

      {/* History Panel */}
      <Grid ref={historyRef} item xs={12} style={{ marginTop: '16px' }}>
      {
          emailCustomer ? (
            <TableComponent customers={[emailCustomer]} />
          ) : (
            !isLoadingEmailCustomer ? (
              <Alert style={{ cursor: 'pointer' }} text={t('panels.search.email.none')} color="warning" noMargin onClick={() => history.push(ROUTER.BLOCK)} />
            ) : null
          )
        }
      </Grid>
    </Grid>
  )
}

const mapStateToProps = ({ ReducerSearch }) => ({
  emailCustomer: ReducerSearch.emailCustomer,
  isLoadingEmailCustomer: ReducerSearch.isLoadingEmailCustomer,
  errorEmailCustomer: ReducerSearch.errorEmailCustomer
})

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default connect(mapStateToProps)(withStyles(styles)(PanelSearchEmail))